import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { FakeLink } from '@design-system/link';
import { Pill } from '@design-system/pill';
export const PillsList = ({ ExternalComponent, dataTestId, forceNoWrap = false, limit = 4, pills, seeLessLabel, seeMoreLabel, }) => {
    const [shouldRenderSeeMore, setShouldRenderSeeMore] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [pillsToRender, setPillsToRender] = useState([]);
    const firstPillMarginLeft = ExternalComponent ? 2 : 0;
    const seeMoreOrLessLabel = useMemo(() => (isCollapsed ? seeMoreLabel : seeLessLabel), [isCollapsed, seeLessLabel, seeMoreLabel]);
    const handleToggleShowPills = useCallback(() => {
        if (isCollapsed) {
            setPillsToRender(pills);
            setIsCollapsed(false);
        }
        else {
            setPillsToRender(pills.slice(0, limit));
            setIsCollapsed(true);
        }
    }, [isCollapsed, limit, pills]);
    useEffect(() => {
        if ((pills === null || pills === void 0 ? void 0 : pills.length) > limit) {
            setShouldRenderSeeMore(true);
            setPillsToRender(pills.slice(0, limit));
        }
        else {
            setPillsToRender(pills);
        }
    }, [limit, pills]);
    if (!pills || (pills === null || pills === void 0 ? void 0 : pills.length) === 0) {
        return null;
    }
    if ((pillsToRender === null || pillsToRender === void 0 ? void 0 : pillsToRender.length) === 0) {
        return _jsx(Box, { height: "32px" });
    }
    return (_jsxs(Box, { alignItems: "center", "data-testid": dataTestId, flexWrap: isCollapsed && forceNoWrap ? 'nowrap' : 'wrap', gridColumnGap: 2, gridRowGap: 2, my: 1, children: [ExternalComponent, pillsToRender === null || pillsToRender === void 0 ? void 0 : pillsToRender.map((pill, index) => (_jsx(Pill, { href: pill.href, ml: index === 0 ? firstPillMarginLeft : 0, onClick: pill.onClick, children: pill.name }, pill.id || index))), shouldRenderSeeMore && (_jsx(FakeLink, { mb: "2px", onClick: handleToggleShowPills, onKeyDown: onEnterOrSpacePress(handleToggleShowPills), children: seeMoreOrLessLabel }))] }));
};
//# sourceMappingURL=PillsList.js.map